import { render } from "./PrivacyPolicyTemplate.vue?vue&type=template&id=aa5c2292&scoped=true&ts=true"
import script from "./PrivacyPolicyTemplate.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicyTemplate.vue?vue&type=script&lang=ts"

import "./PrivacyPolicyTemplate.vue?vue&type=style&index=0&id=aa5c2292&lang=scss&scoped=true"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa5c2292"]])

export default __exports__